import { withAuth } from '../../context/Auth';
import withContainer from '../../components/Container/withContainer';
import { AssignedCourse } from 'api/courses/courses.types';
import { PowerTable } from 'ui/PowerTable';
import { ColumnProps } from 'ui/Table';
import {
    getAssignedCourses,
    deleteCourseAssignments
} from 'api/courses/courses';
import { RouterPaths } from 'helpers/router-paths';
import {
    ASSIGNED_STUDENTS_DELETE_CORE_WORD,
    ASSIGNED_STUDENTS_DELETE_WORDS
} from '../courses/constants';

const ASSIGNED_COURSES_COLUMNS: ColumnProps<AssignedCourse> = {
    'student.user.fullName': {
        title: 'ФИО',
        width: 300
    },
    'course.title': {
        title: 'Название курса',
        width: 500
    },
    dateStartLearning: {
        title: 'Начало обучения',
        width: 170,
        type: 'date'
    },
    dateEndLearning: {
        title: 'Конец обучения',
        width: 170,
        type: 'date'
    }
};

const AssignedCoursesList = () => (
    <PowerTable
        columns={ASSIGNED_COURSES_COLUMNS}
        getter={getAssignedCourses}
        linkGetter={RouterPaths.CourseAssignment}
        onDelete={deleteCourseAssignments}
        deleteWords={ASSIGNED_STUDENTS_DELETE_WORDS}
        deleteCoreWord={ASSIGNED_STUDENTS_DELETE_CORE_WORD}
    />
);

export default withAuth(
    withContainer(AssignedCoursesList, {
        heading: 'Назначенные курсы',
        flex: true
    })
);
